import type { TFirebaseProjectID } from '@team-milva/lab-constants/environments'

/**
 * The Firebase web-app config of each environment's project, keyed by project ID.
 *
 * These are the public client identifiers Firebase Hosting itself serves at
 * `/__/firebase/init.json` on every deployed site (the API key is not a secret — access is
 * governed by Auth, the rules and API restrictions). They are baked in per build rather than
 * fetched at runtime, the way lab-management does it, because this app also ships as a Capacitor
 * shell whose origin (`capacitor://localhost`) has no Hosting `init.json` to ask.
 *
 * Which entry applies is decided by the build mode in `host.ts` (`production` → prod, `stage` →
 * stage, anything else → dev). Before 2026-10-05 this was a single hardcoded dev config used by
 * every build, so a prod build would have called the prod API against dev's Auth and Firestore.
 */
export interface IFirebaseWebConfig {
  apiKey: string
  authDomain: string
  projectId: TFirebaseProjectID
  storageBucket: string
  messagingSenderId: string
  appId: string
}

export const FIREBASE_WEB_CONFIGS: Record<TFirebaseProjectID, IFirebaseWebConfig> = {
  'lab-services-dev': {
    apiKey: 'AIzaSyCACYSwFgv_y-GHel1HpchrDB_Wviu4aus',
    authDomain: 'lab-services-dev.firebaseapp.com',
    projectId: 'lab-services-dev',
    storageBucket: 'lab-services-dev.firebasestorage.app',
    messagingSenderId: '1028648737944',
    appId: '1:1028648737944:web:9e4c95fab0dd0a017784ed',
  },
  'lab-services-stage': {
    apiKey: 'AIzaSyAVVWbVOMvMEPafSpCWuK8ayjpz9Dve3IQ',
    authDomain: 'lab-services-stage.firebaseapp.com',
    projectId: 'lab-services-stage',
    storageBucket: 'lab-services-stage.firebasestorage.app',
    messagingSenderId: '757106718540',
    appId: '1:757106718540:web:a1e069f45a6e94a29a41e9',
  },
  'lab-services-prod': {
    apiKey: 'AIzaSyDrmUbrAoChBeNA59kWFjwOh5XCoPp3_14',
    authDomain: 'lab-services-prod.firebaseapp.com',
    projectId: 'lab-services-prod',
    storageBucket: 'lab-services-prod.firebasestorage.app',
    messagingSenderId: '368654213641',
    appId: '1:368654213641:web:949d449e54eccdbc6b0ed8',
  },
}
